import React from 'react';
class MenuHeader extends React.Component{
      render(){
            return(<div className="footer">
                  <span className="info">
                        {/* Legg fotnoter her! */}
                  </span>
            </div>);
      }
}
export default MenuHeader;
